import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkService {

  private callbackSubject = new Subject<string>();

  readonly callback$ = this.callbackSubject.asObservable();

  async iniciar(): Promise<void> {

    // Aplicativo já aberto
    await App.addListener('appUrlOpen', ({ url }) => {

      console.log('🔗 Deep Link recebido:', url);

      this.callbackSubject.next(url);
    });

    // Aplicativo aberto pelo Deep Link
    const launchUrl = await App.getLaunchUrl();

    if (launchUrl?.url) {

      console.log(
        '🚀 Deep Link de inicialização:',
        launchUrl.url
      );

      this.callbackSubject.next(launchUrl.url);
    }
  }
}